import { Participant } from '../../../types';
import { safeDrawMedia } from './draw-helpers';
import { getPngImage } from './draw-images';
import { Area } from './dtmf/types';

export const drawParticipantReaction = (
    ctx: CanvasRenderingContext2D,
    area: Area,
    participant: Participant,
    { size, indent }: { size: number; indent: number }
) => {
    const reactionType = participant.reaction?.reactionType;

    if (!reactionType) {
        return;
    }

    const img = getPngImage(reactionType);

    const imgArea = {
        width: size,
        height: size,

        x: area.x + area.width - size - indent,
        y: area.y + indent,
    };

    safeDrawMedia(ctx, imgArea, img, { mode: 'contain' });
};
